export default __webpack_public_path__ + "static/article-travel-now-with-a-personal-loan-or-credit-card-08bb7d5255a8dba7c83537f2c1a4604c.jpg";